import { render, staticRenderFns } from "./TIPO_COMPRE_MARCA.vue?vue&type=template&id=41d68ff8"
import script from "./TIPO_COMPRE_MARCA.vue?vue&type=script&lang=js"
export * from "./TIPO_COMPRE_MARCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports